import React, {Component} from 'react';

export default class ProfileText extends Component {
    render() {
        return (
            <div className="profile-text">
                <h2>About</h2>
                <span>
                     <p>
                         <p>
                             I'm a sociable computer science graduate with a strong interdisciplinary focus
                             on <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/Artificial_intelligence'}>AI</a>, 
                             spanning <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/AI_alignment'}>AI Alignment</a>
                             , <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/AI_safety'}>AI Safety</a>
                             , <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/Regulation_of_artificial_intelligence'}>AI Governance & Policy</a>, 
                             as well as <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/Philosophy'}>Philosophy</a>
                             , <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/Political_science'}>Political Science</a>
                             , <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/Social_science'}>Social Sciences</a>, and <a target={'_blank'} rel={'noreferrer'} href={'https://en.wikipedia.org/wiki/Psychology'}>Psychology</a>.
                         </p>
                         <p>
                             I’m interested in bridging AI research and real-world impact, exploring how technology can make this world a better place, and sharing what I learn along the way.
                         </p>
                         <p>
                             Check out my co-authored paper <a target={'_blank'} rel={'noreferrer'} href={'https://aclanthology.org/2024.findings-emnlp.384/'}>VideoINSTA: Zero-shot Long Video Understanding via Informative Spatial-Temporal Reasoning with LLMs</a>, accepted
                             to <a target={'_blank'} rel={'noreferrer'} href={'https://2024.emnlp.org/'}>EMNLP 2024</a>, as well as the
                             corresponding <a target={'_blank'} rel={'noreferrer'} href={'https://github.com/mayhugotong/VideoINSTA'}>video reasoning framework on GitHub</a>.
                         </p>
                         <p>
                             Outside of research, I’m a music-loving guitarist & singer, and I love surfing the Eisbach (E2) river wave in Munich as well as performing flow arts.
                         </p>
                         {/*<p>*/}
                         {/*    Additionally, I have gained a lot of coding experience at*/}
                         {/*    the <a target={'_blank'} rel={'noreferrer'} href={'https://www.doubleslash.de/'}>doubleSlash Net-Business GmbH</a> doing*/}
                         {/*    an internship as well as a working student job.*/}
                         {/*    Also, I have gained a lot of experiences founding an own company: Hollerkini.*/}
                         {/*</p>*/}
                     </p>
                    </span>
            </div>
        );
    }
}
